// 結構化驗收條件的分類 —— 對應 specforge 端 lib/acceptance.ts 的 AC_CATEGORIES。
// 跨 repo API 契約各自定義一份;這份多帶「顯示順序 + 顏色」供 PMS Drawer 分組呈現。
export const AC_CATEGORY_ORDER = ['功能', '邊界', '錯誤'];

export const AC_CATEGORY_META = {
  功能: { color: '#0e7090' }, // 青:正常流程
  邊界: { color: '#b54708' }, // 橘:邊界情境
  錯誤: { color: '#d92d20' }, // 紅:失敗/異常處理
};

// QA 勾選結果的顯示
export const AC_STATUS_META = {
  pass: { label: '通過', color: '#039855' },
  fail: { label: '未過', color: '#d92d20' },
};
